import { render, staticRenderFns } from "./commentPersonItem.vue?vue&type=template&id=25b323d7&scoped=true&lang=html&"
import script from "./commentPersonItem.vue?vue&type=script&lang=js&"
export * from "./commentPersonItem.vue?vue&type=script&lang=js&"
import style0 from "./commentPersonItem.vue?vue&type=style&index=0&id=25b323d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b323d7",
  null
  
)

export default component.exports